import '/app/brewery-packages/content/content-editor-plugin-title/src/Title.css-raw';
export default {
  "title": "contacts-cbf4f629-title--87Tha"
};